import React from 'react';
import { Paper, Box, Button, TextField, Typography } from '@material-ui/core';
import { Form, Field } from 'react-final-form';
import ImageUploadField from '../ImageUploadField';

const LevelSelectorTab = ({ config, onSave }) => {
  const handleSubmit = (values) => {
    onSave({
      ...config,
      level_selector_background: values.level_selector_background,
      level_selector_modal_bg_color: values.level_selector_modal_bg_color,
      level_selector_cta_color: values.level_selector_cta_color,
    });
  };

  const initialValues = {
    level_selector_background: config?.level_selector_background,
    level_selector_modal_bg_color: config?.level_selector_modal_bg_color,
    level_selector_cta_color: config?.level_selector_cta_color,
  };

  return (
    <Paper>
      <Box p={3}>
        <Typography variant="h6" gutterBottom>
          Level Selector Settings
        </Typography>
        <Form
          onSubmit={handleSubmit}
          initialValues={initialValues}
          render={({ handleSubmit, submitting }) => (
            <form onSubmit={handleSubmit}>
              <Box display="flex" flexDirection="column" gap={2}>
                <ImageUploadField
                  name="level_selector_background"
                  label="Background Image"
                  folder="word-finder/"
                  helperText="Minimum 375Wx825H"
                />

                <Field name="level_selector_modal_bg_color">
                  {({ input }) => (
                    <Box mt={2}>
                      <TextField
                        label="Modal Background Color"
                        value={input.value}
                        onChange={input.onChange}
                        placeholder="#2f2f2f"
                        helperText="HEX color code (opacity is preserved)"
                        fullWidth
                      />
                      <Box mt={1} display="flex" alignItems="center" gap={1}>
                        <Box
                          width={40}
                          height={40}
                          bgcolor={input.value || '#2f2f2f'}
                          borderRadius={4}
                          border="1px solid #ccc"
                        />
                        <input
                          type="color"
                          value={input.value || '#2f2f2f'}
                          onChange={(e) => input.onChange(e.target.value)}
                          style={{ cursor: 'pointer' }}
                        />
                      </Box>
                    </Box>
                  )}
                </Field>

                <Field name="level_selector_cta_color">
                  {({ input }) => (
                    <Box mt={2}>
                      <TextField
                        label="Tovabb CTA Button Color"
                        value={input.value}
                        onChange={input.onChange}
                        placeholder="#db0a40"
                        helperText="HEX color code"
                        fullWidth
                      />
                      <Box mt={1} display="flex" alignItems="center" gap={1}>
                        <Box
                          width={40}
                          height={40}
                          bgcolor={input.value || '#db0a40'}
                          borderRadius={4}
                          border="1px solid #ccc"
                        />
                        <input
                          type="color"
                          value={input.value || '#db0a40'}
                          onChange={(e) => input.onChange(e.target.value)}
                          style={{ cursor: 'pointer' }}
                        />
                      </Box>
                    </Box>
                  )}
                </Field>

                <Box mt={3}>
                  <Button type="submit" variant="contained" color="primary" disabled={submitting}>
                    Save Level Selector Settings
                  </Button>
                </Box>
              </Box>
            </form>
          )}
        />
      </Box>
    </Paper>
  );
};

export default LevelSelectorTab;
